import script from "./logoutComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./logoutComponent.vue?vue&type=script&setup=true&lang=js"

import "./logoutComponent.vue?vue&type=style&index=0&id=a0b51052&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0b51052"]])

export default __exports__